import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  list: {
    maxHeight: '40vh',
    overflow: 'scroll',
  },
  modal: {
    maxWidth: '800px',
    overflowY: 'visible',
  },
  paperWidthSm: {
    maxHeight: 'inherit',
  },
  gridPadding: {
    padding: '0px 20px 20px 20px !important',
  },
  gridPaddingMap: {
    padding: '0px 20px !important',
    '& > div': {
      height: '300px !important',
    },
  },
  expandableList: {
    transition: 'max-height 0.3s',
    width: '100%',
    borderRadius: 4,
  },
  viewMoreBtn: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginTop: 4,
  },
  viewMoreText: {
    color: '#222',
    textDecoration: 'underline',
    fontSize: 16,
    fontWeight: 500,
  },
  expandIcon: {
    marginLeft: 4,
  },
  warningText: {
    color: '#ff9900',
    fontWeight: 700,
  },
  expandableListCollapsed: {
    maxHeight: '24px',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    border: 'none',
    background: 'transparent',
    paddingRight: 0,
  },
  expandableListExpanded: {
    maxHeight: '96px',
    overflowY: 'auto',
    whiteSpace: 'normal',
    textOverflow: 'clip',
    overflowX: 'hidden',
    border: '1px solid #eee',
    background: '#fafafa',
    paddingRight: 8,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '40px 20px 60px',
    width: '100%',
  },
}))

export default useStyles
